// Sea passages (GDD §4): canals and straits ships sail through that the 0.25° land mask closes (a canal or a narrow
// strait is thinner than a mask cell). The sea-lane grid (sim/src/pathing/sea-lanes.ts) carves each one open along
// its polyline. Every passage runs from open water to open water, so both of its ends are mask water.
// Straits the mask already keeps open (Gibraltar, Dardanelles, Kerch, Bab-el-Mandeb) are not listed. The Great
// Lakes are land in the mask, so no seaway leads to them.

import { ContentValidationError } from './errors'
import { LAND_MASK } from './geo'

export interface SeaPassage {
  readonly name: string
  /** [lat, lon] in degrees, from open water on one side to open water on the other. */
  readonly points: readonly (readonly [number, number])[]
}

export const SEA_PASSAGES: readonly SeaPassage[] = [
  { name: 'Suez Canal', points: [[31.6, 32.3], [31.26, 32.31], [30.6, 32.32], [30.35, 32.38], [29.95, 32.56], [29.6, 32.65]] },
  { name: 'Panama Canal', points: [[9.6, -79.9], [9.36, -79.91], [9.27, -79.92], [9.1, -79.75], [8.99, -79.59], [8.88, -79.52], [8.6, -79.45]] },
  { name: 'Bosporus', points: [[41.45, 29.2], [41.23, 29.12], [41.08, 29.06], [41.0, 28.99], [40.85, 28.95]] },
  { name: 'Kiel Canal', points: [[53.85, 8.8], [53.89, 9.14], [54.3, 9.67], [54.37, 10.14], [54.55, 10.3]] },
  { name: 'Øresund', points: [[56.5, 12.3], [56.04, 12.62], [55.7, 12.7], [55.35, 12.85]] },
]

export function validateSeaPassages(): void {
  for (const passage of SEA_PASSAGES) {
    const first = passage.points[0]
    const last = passage.points[passage.points.length - 1]
    if (first === undefined || last === undefined || passage.points.length < 2) throw new ContentValidationError(`sea passage ${passage.name} needs two points`)
    for (const [lat, lon] of [first, last]) {
      if (LAND_MASK.isLand(lat, lon)) throw new ContentValidationError(`sea passage ${passage.name} ends on land at (${lat}, ${lon})`)
    }
  }
}
